module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAARVBMVEUAAADN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uTN1uRgdMomAAAAFnRSTlMAiETcGHKqHsEF1fYNtS064WA8ZJZalVbjwwAAAF1JREFUCNdVjlsSgCAIRakUI7V37H+pXXWY7PzAGRguNOlHICplmSucmsaLDK04dMGLaYB6zWIqecFRNk2x3uyWD91dpyc7Mv0H3QMoQVv35YqxeDTPCGAFxzFR4wVDogmObvTdDgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t0.png
// module id = GWjY
// module chunks = 15